import { DashboardModule } from '@domain-group/suit-theme'

import usePortals from '@hooks/usePortals'

import AvailablePortalListItem from './AvailablePortalListItem'

interface AvailablePortalsProps {
  activePortalIds: number[],
}

const AvailablePortals = (props: AvailablePortalsProps) => {
  const { activePortalIds } = props

  const portalsPayload = usePortals({
    filters: {
      exclude_ids: activePortalIds,
      export_enabled: 'true',
    },
  })

  const { hasFilteredPortals, filteredPortals } = portalsPayload

  if (!hasFilteredPortals) return null

  return (
    <DashboardModule contentBoxProps={{ flexDirection: 'column' }} title="Available Portals">
      {filteredPortals.map(portal => (
        <AvailablePortalListItem key={portal.id} portal={portal} />
      ))}
    </DashboardModule>
  )
}

export default AvailablePortals
